import React, { useState, createContext, memo } from 'react'
const defaultValues = false

export const DarkContext = createContext(defaultValues)

function DarkContextWrapper({ children }) {
    const [isDark, setIsDark] = useState(defaultValues)
    return (
        <DarkContext.Provider value={{ isDark, setIsDark }}>
            {children}
        </DarkContext.Provider>
    )
}

export default memo(DarkContextWrapper)